import type { BuildingSocietySavingsOverviewCountryConfig } from '../../BuildingSocietySavingsOverviewConfig';

export const savingsOverview: BuildingSocietySavingsOverviewCountryConfig = {
    highlights: {
        displayMonthlyAmount: true,
    },
    list: {
        displayAgreementNumber: false,
        displaySigningDate: true,
        displayExpiryDate: true,
        displayContractAmount: true,
        displayBeneficiaries: true,
        displaySubProductI18N: true,
        displayInitialDepositDate: true,
        displayFeeInfo: true,
        displayMinimumSavingsPeriod: true,
        displayTerminationPayout: true,
    },
};
